import Atellier from './Atellier';

export default Atellier;



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/